module.exports = __webpack_public_path__ + "static/media/track_ext_pf.ba0f05e3.svg";